// "use client";

// import React, { useEffect, useState } from "react";
// import CommonCard from "./CommonCard";
// import "../../../app/globals.css";

// const PortfolioCommonComponent = () => {
//     const [cardData, setCardData] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState("All Project");
//     const [showMoreCrads, setShowMoreCrads] = useState(6);

//     const loadDataFromURL = async () => {
//         try {
//             const res = await fetch(
//                 `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/blog-portfolios?populate=*`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${process.env.NEXT_PUBLIC_SUPER_TOKEN}`,
//                     },
//                 }
//             );
//             const data = await res.json();
//             setCardData(data.data);
//         } catch (err) {
//             console.log("🚀 ~ loadDataFromURL ~ err:", err);
//         }
//     };

//     const filterCategory = cardData.map((i) => i.attributes.category);
//     //filter data
//     const CategoryData = new Set(filterCategory);
//     // Create an array with 'all' first, then sort other categories
//     const finalCategoryData = [
//         "All Project",
//         ...Array.from(CategoryData).sort((a, b) => a.localeCompare(b)),
//     ];

//     const handleCategoryClick = (category) => {
//         setSelectedCategory(category);
//     };

//     useEffect(() => {
//         // dataFetch();
//         loadDataFromURL();
//     }, []);

//     const filteredData =
//       selectedCategory === "All Project"
//         ? cardData
//         : cardData.filter((item) => item?.attributes?.category === selectedCategory);

//     const displayedData = filteredData.slice(0, showMoreCrads);
//     const handleReadMore = () => {
//         setShowMoreCrads((prv) => prv + 6);
//     };

//     return (
//       <>
//         <div className="container mx-auto flex flex-col">
//           <div className="text-center md:mt-16 my-5 ">
//             <h2 className={`text-black text-2xl lg:text-5xl !leading-snug font-bold font-manrope`}>
//               Latest Projects
//             </h2>
//           </div>

//           <div className="flex items-center gap-3 mb-12 border-b border-b-[#E9E9E9] overflow-x-auto">
//             {finalCategoryData.map((val, i) => {
//               return (
//                 <button
//                   key={i}
//                   className={`cursor-pointer text-nowrap mt-5 text-sm transition-all duration-300 ease-in-out w-fit rounded-sm border-b border-b-transparent mb-3 py-1 px-3 ${
//                     selectedCategory === val
//                       ? "text-black bg-[#400ead28] rounded-md"
//                       : "text-[#666666] hover:text-black hover:bg-[#400ead28] rounded-md"
//                   }`}
//                   onClick={() => handleCategoryClick(val)}
//                 >
//                   <span className="leading-4">{val}</span>
//                 </button>
//               );
//             })}
//           </div>

//           <CommonCard cardData={displayedData} />

//           {displayedData.length < filteredData.length && (
//             <div className="flex justify-center items-center my-14">
//               <button className={`common-blue-button-style`} onClick={() => handleReadMore()}>
//                 Read More
//               </button>
//             </div>
//           )}

//           <div className="border-b-2 horgintalGradientBorder mt-16 text-center"></div>
//         </div>
//       </>
//     );
// };

// export default PortfolioCommonComponent;

"use client";

import React, { useEffect, useState } from "react";
import CommonCard from "./CommonCard";
import "../../../app/globals.css";

// ✅ Static case study added here
const STATIC_CARDS = [
  {
    id: "static-1",
    attributes: {
      title: "E-Commerce Website Redesign",
      category: "Web Design",
      description: "A complete redesign of an e-commerce platform to improve user experience and increase conversions.",
      link: "https://your-case-study-link.com",
      logo: {
        data: [
          {
            attributes: {
              url: "https://your-full-logo-url.png",
            },
          },
        ],
      },
      image: {
        data: [
          {
            attributes: {
              url: "https://your-full-image-url.png",
            },
          },
        ],
      },
    },
  },
];

const PortfolioCommonComponent = () => {
    const [cardData, setCardData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All Project");
    const [showMoreCrads, setShowMoreCrads] = useState(6);

    const loadDataFromURL = async () => {
        try {
            const res = await fetch(
                `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/blog-portfolios?populate=*`,
                {
                    headers: {
                        Authorization: `Bearer ${process.env.NEXT_PUBLIC_SUPER_TOKEN}`,
                    },
                }
            );
            const data = await res.json();
            setCardData([...data.data, ...STATIC_CARDS]); // ✅ merge API + static
        } catch (err) {
            console.log("🚀 ~ loadDataFromURL ~ err:", err);
            setCardData(STATIC_CARDS); // ✅ fallback if API fails
        }
    };

    const filterCategory = cardData.map((i) => i.attributes.category);
    //filter data
    const CategoryData = new Set(filterCategory);
    // Create an array with 'all' first, then sort other categories
    const finalCategoryData = [
        "All Project",
        ...Array.from(CategoryData).sort((a, b) => a.localeCompare(b)),
    ];

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };

    useEffect(() => {
        loadDataFromURL();
    }, []);

    const filteredData =
      selectedCategory === "All Project"
        ? cardData
        : cardData.filter((item) => item?.attributes?.category === selectedCategory);

    const displayedData = filteredData.slice(0, showMoreCrads);
    const handleReadMore = () => {
        setShowMoreCrads((prv) => prv + 6);
    };

    return (
      <>
        <div className="container mx-auto flex flex-col">
          <div className="text-center md:mt-16 my-5 ">
            <h2 className={`text-black text-2xl lg:text-5xl !leading-snug font-bold font-manrope`}>
              Latest Projects
            </h2>
          </div>

          <div className="flex items-center gap-3 mb-12 border-b border-b-[#E9E9E9] overflow-x-auto">
            {finalCategoryData.map((val, i) => {
              return (
                <button
                  key={i}
                  className={`cursor-pointer text-nowrap mt-5 text-sm transition-all duration-300 ease-in-out w-fit rounded-sm border-b border-b-transparent mb-3 py-1 px-3 ${
                    selectedCategory === val
                      ? "text-black bg-[#400ead28] rounded-md"
                      : "text-[#666666] hover:text-black hover:bg-[#400ead28] rounded-md"
                  }`}
                  onClick={() => handleCategoryClick(val)}
                >
                  <span className="leading-4">{val}</span>
                </button>
              );
            })}
          </div>

          <CommonCard cardData={displayedData} />

          {displayedData.length < filteredData.length && (
            <div className="flex justify-center items-center my-14">
              <button className={`common-blue-button-style`} onClick={() => handleReadMore()}>
                Read More
              </button>
            </div>
          )}

          <div className="border-b-2 horgintalGradientBorder mt-16 text-center"></div>
        </div>
      </>
    );
};

export default PortfolioCommonComponent;